import styled from 'styled-components'
import { Box, Theme } from '@web-apps/ui-shared'

export const StyledContainer = styled(Box)`
  background: ${Theme.Colors.background.global};
`
